import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import { STRINGS } from 'src/commons';

const MembershipPlanForm = ({
  errors,
  handleBlur,
  handleChange,
  handleSubmit,
  isSubmitting,
  touched,
  values,
  heading = '',
  handleCloseModal
}) => {
  return (
    <form onSubmit={handleSubmit}>
      <Box sx={{ mb: 3, display: 'flex', justifyContent: 'space-between' }}>
        <Typography color="textPrimary" variant="h2">
          {heading}
        </Typography>
        {handleCloseModal && (
          <CloseIcon sx={{ cursor: 'pointer' }} onClick={handleCloseModal} />
        )}
      </Box>

      <TextField
        error={Boolean(touched.name && errors.name)}
        fullWidth
        helperText={touched.name && errors.name}
        label="Name"
        margin="normal"
        name="name"
        onBlur={handleBlur}
        onChange={handleChange}
        type="text"
        value={values.name}
        variant="outlined"
      />
      <TextField
        error={Boolean(touched.description && errors.description)}
        fullWidth
        helperText={touched.description && errors.description}
        label="Description"
        margin="normal"
        name="description"
        onBlur={handleBlur}
        onChange={handleChange}
        type="text"
        value={values.description}
        variant="outlined"
      />
      <TextField
        error={Boolean(touched.amount && errors.amount)}
        helperText={touched.amount && errors.amount}
        fullWidth
        label="Amount"
        margin="normal"
        name="amount"
        onBlur={handleBlur}
        onChange={handleChange}
        type="number"
        value={values.amount || ''}
        variant="outlined"
      />
      <FormControl
        variant="outlined"
        fullWidth
        margin="normal"
        id="membership-plan-select"
      >
        <InputLabel id="membership-plan-label">
          {STRINGS.MEMBERSHIP_PLAN}
        </InputLabel>
        <Select
          labelId="membership-plan-label"
          id="membership-plan"
          value={values.duration}
          onChange={handleChange}
          label="Membership Plan"
          name="duration"
        >
          <MenuItem name="membershipPlan" value={0}>
            {STRINGS.QUARTERLY}
          </MenuItem>
          <MenuItem name="membershipPlan" value={1}>
            {STRINGS.HALF_YEARLY}
          </MenuItem>
          <MenuItem name="membershipPlan" value={2}>
            {STRINGS.YEARLY}
          </MenuItem>
          <MenuItem name="membershipPlan" value={3}>
            {STRINGS.MONTHLY}
          </MenuItem>
        </Select>
      </FormControl>

      <Box sx={{ py: 2 }}>
        <Button
          sx={{
            textTransform: 'none'
          }}
          color="primary"
          disabled={isSubmitting}
          fullWidth
          size="large"
          type="submit"
          variant="contained"
        >
          {heading}
        </Button>
      </Box>
    </form>
  );
};

export default MembershipPlanForm;
